let headerTitle = document.getElementById('header-title')

if(headerTitle != null) {
    window.addEventListener('scroll', () => {
        if (document.body.scrollTop > 150 || document.documentElement.scrollTop > 150) {
            headerTitle.classList.add('on-scroll')
        } else {
            headerTitle.classList.remove('on-scroll')
        }
    }, { passive: true })
}
